import { WrittenLogo } from 'assets/icons';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { Breakpoints } from 'common/enums';
import { AppBreadcrumb } from 'common/app-breadcrumb';
import { Notification } from 'common/notification';
import { TopnavDropdownMenu } from 'common/topnav-dropdown-menu';
import { appActions, AppContext } from 'context';
import { trackCustomEvent } from 'helpers/analytics';
import { useMediaQuery } from 'hooks/use-media-query';
import { UserController } from 'networking/controllers/user-controller';
import { captureEvent } from 'posthog';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { goToPage, RouteName } from 'routes';
import styles from './navbar.module.scss';

const handleGoToVaults = () => {
  goToPage(RouteName.Vaults);
};

export const Navbar = () => {
  const { dispatch, state } = useContext(AppContext);
  const [showError, setShowError] = useState(false);
  const { guestToken } = useParams<ParamsType>();
  const isSmallScreen = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);

  const logOutUser = async () => {
    captureEvent('logout');
    trackCustomEvent('logOut');
    try {
      await UserController.signOutUser();
      dispatch({ type: appActions.SESSION_EXPIRED });
      goToPage(RouteName.SignIn);
    } catch (e) {
      setShowError(true);
    }
  };
  const showLogOutErrorNotification = () => (
    <Notification
      message="We couldn’t log you out. Please try again."
      handleClose={() => setShowError(false)}
    />
  );

  const authenticate = async () => {
    if (state.logged) {
      return;
    }

    try {
      const data = await UserController.me();
      dispatch({ type: appActions.USER_LOGGED, data });
    } catch (e) {
      dispatch({ type: appActions.SESSION_EXPIRED });
    }
  };

  useEffect(() => {
    authenticate();
  }, []);

  useEffect(() => {
    if (guestToken) {
      UserController.addGuestTokenHeader(guestToken);
      return UserController.removeGuestTokenHeader;
    }
    return undefined;
  }, [guestToken]);

  return (
    <>
      {showError && showLogOutErrorNotification()}
      <nav className={styles.container}>
        <div className={styles.leftSection}>
          <button
            type="button"
            onClick={handleGoToVaults}
            className={styles.logo}
          >
            <WrittenLogo />
          </button>
          <AppBreadcrumb />
        </div>
        {state.logged ? (
          <TopnavDropdownMenu onLogout={logOutUser} />
        ) : (
          <div className={styles.nonLoggedContainer}>
            <Button
              buttonStyle={ButtonStyle.PrimaryGhost}
              buttonSize={isSmallScreen ? ButtonSize.Small : undefined}
              onClick={() => goToPage(RouteName.SignIn)}
            >
              Login
            </Button>
            <Button
              buttonSize={isSmallScreen ? ButtonSize.Small : undefined}
              onClick={() => goToPage(RouteName.SignIn)}
            >
              Create a Vault
            </Button>
          </div>
        )}
      </nav>
    </>
  );
};
